import React from 'react';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { Popconfirm, Space, Tooltip } from 'antd';
import {
    DeleteTwoTone,
    EditOutlined,
    FileSearchOutlined,
    FileTextOutlined,
} from '@ant-design/icons';
import { removeProjectCosts } from '../../../../../../../store/billing';
import {
    DISPLAY_DATE_FORMAT,
    renderAmount,
} from '../../../../../../../../static/utils';

export default (onActionClick = () => {}, showActions = true) => {
    const dispatch = useDispatch();

    return React.useMemo(() => [
        {
            key: 'po_date',
            title: 'Date',
            dataIndex: 'po_date',
            render: (value) => moment(value).format(DISPLAY_DATE_FORMAT),
        },
        {
            key: 'vendor',
            title: 'Vendor',
            dataIndex: 'vendor',
            render: (vendor) => vendor?.name || '-',
        },
        // {
        //     key: 'reason',
        //     title: 'Reason',
        //     dataIndex: 'reason',
        //     render: (value) => PROJECT_COST_REASONS[value] || '-',
        // },
        {
            key: 'amount',
            title: 'Amount',
            dataIndex: 'amount',
            render: renderAmount,
        },
        {
            key: 'billed',
            title: 'Billed so far',
            dataIndex: 'cumm_billed_so_far',
            render: renderAmount,
        },
        // {
        //     key: 'cost',
        //     title: 'Cost to date',
        //     dataIndex: 'cumm_cost_to_date',
        //     render: renderAmount
        // },
        {
            key: 'remaining',
            title: 'Remaining to bill',
            dataIndex: 'remaining_to_be_billed',
            render: renderAmount,
        },
        {
            key: 'files_count',
            title: 'Attachment(s)',
            dataIndex: 'files_count',
            render: (value) => (
                <Space>
                    <FileTextOutlined />
                    {value}
                </Space>
            ),
        },
        ...[
            showActions
                ? {
                      title: 'Actions',
                      key: 'action',
                      dataIndex: 'action',
                      align: 'center',
                      render: (_, record) => (
                          <Space size={10}>
                              <Tooltip title="Details">
                                  <FileSearchOutlined
                                      style={{ fontSize: 17 }}
                                      onClick={() => onActionClick('view', record)}
                                  />
                              </Tooltip>
                              <Tooltip title="Edit">
                                  <EditOutlined
                                      style={{ fontSize: 17 }}
                                      onClick={() => onActionClick('edit', record)}
                                  />
                              </Tooltip>
                              <Popconfirm
                                  title="Are you sure?"
                                  onConfirm={(ev) => {
                                      ev.stopPropagation();
                                      dispatch(
                                          removeProjectCosts(record.master_project, [record.id]),
                                      );
                                  }}
                              >
                                  <Tooltip title="Delete">
                                      <DeleteTwoTone
                                          style={{ fontSize: 17 }}
                                          twoToneColor="#f56666"
                                      />
                                  </Tooltip>
                              </Popconfirm>
                          </Space>
                      ),
                  }
                : {},
        ],
    ]);
};
